import { PartialDeep } from 'type-fest';
import * as yup from 'yup';

import { makeValidateSync } from '@cast/utils';

import { hpaV1ValidationSchema } from './hpa-v1-validation.schema';
import { vpaValidationSchema } from './vpa-validation.schema';

const rightsizingSettingsV1ValidationSchema = yup.object({
  horizontalRightsizing: hpaV1ValidationSchema,
  verticalRightsizing: yup.object({
    policy: vpaValidationSchema,
  }),
});

export type RightsizingSettingsV1ValidationSchema = PartialDeep<
  yup.InferType<typeof rightsizingSettingsV1ValidationSchema>
>;
export const validateRightsizingSettingsV1 = makeValidateSync(
  rightsizingSettingsV1ValidationSchema
);
